export default "__VITE_ASSET__DJ4wm1se__"